import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { Amplify } from 'aws-amplify';

import { ConfigContext } from './ConfigContext';
import { setConfig } from './configService';

export const ConfigProvider = ({ children }) => {
  const [appConfig, setAppConfig] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch('/deployment-config.json', {
          cache: 'no-store',
        });

        if (!res.ok) {
          throw new Error('Failed to load config');
        }

        const data = await res.json();
        const normalizedAppConfig = {
          apiUrl: data.API_URL,
          userPoolId: data.USER_POOL_ID,
          clientId: data.CLIENT_ID,
          env: data.ENV,
          envLabel: data.ENV_LABEL,
          reCaptchaKey: data.RECAPTCHA_KEY,
          quickCampaignReCaptchaKey: data.QUICKPAY_CAMPAIGN_RECAPTCHA_KEY,
          servicingPhone: data.SERVICING_PHONE,
          collectionsPhone: data.COLLECTIONS_PHONE,
          massachusettsErrorPhone: data.MASSACHUSETTS_ERROR_PHONE,
          sessionTimeoutInMinutes: data.SESSION_TIMEOUT_IN_MINUTES,
          delay: data.DELAY,
          isInMaintenance: data.IS_IN_MAINTENANCE,
          targetLTV: data.TARGET_LTV,
          pageSenseId: data.PAGESENSE_ID
        };
        setConfig(normalizedAppConfig);
        setAppConfig(normalizedAppConfig);

        Amplify.configure({
          Auth: {
            Cognito: {
              userPoolId: normalizedAppConfig.userPoolId,
              userPoolClientId: normalizedAppConfig.clientId,
            },
          },
        });

        cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
      } catch (err) {
        console.error('Config load error:', err);
        setConfig({});
        setAppConfig({});
      }
    };

    loadConfig();
  }, []);

  if (!appConfig) {
    return null;
  }

  return (
    <ConfigContext.Provider value={appConfig}>
      {children}
    </ConfigContext.Provider>
  );
};

ConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
